import { render, staticRenderFns } from "./bank-acc-select.vue?vue&type=template&id=20995a92&scoped=true&"
import script from "./bank-acc-select.vue?vue&type=script&lang=js&"
export * from "./bank-acc-select.vue?vue&type=script&lang=js&"
import style0 from "./bank-acc-select.vue?vue&type=style&index=0&id=20995a92&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20995a92",
  null
  
)

component.options.__file = "bank-acc-select.vue"
export default component.exports